import axios from 'lib/axios';

const createDivision = async (value) => {
  const { data } = await axios.post('/admin/division', value);
  return data;
};

const getAllDivisions = async (query = '') => {
  const { data } = await axios.get(`/admin/division?query=${query}`);
  return data;
};

const getDivisionById = async (id) => {
  const { data } = await axios.get(`/admin/division/${id}`);
  return data;
};

const updateDivisionById = async (value) => {
  const { body, id } = value;
  const { data } = await axios.put(`/admin/division/${id}`, body);
  return data;
};

export { createDivision, getAllDivisions, getDivisionById, updateDivisionById };
